import { useGetMyProfile } from "@store/hooks";
import { useAuth } from "@lib/auth/useAuth";

export const useIsLoyaltyMember = () => {
    const { data: customer, isLoading } = useGetMyProfile();
    const { status } = useAuth();
    const isKnown =
        status === "unauthenticated" || (status === "authenticated" && customer !== undefined);

    return {
        isLoyaltyMember: Boolean(customer?.loyalty),
        isLoading,
        isKnown,
    };
};
